module.exports = __webpack_public_path__ + "static/media/image-placeholder.1ba9cec3.svg";